var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[(_vm.failed)?[_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n      We were unable to log you in.\n    ")])]:[_c('loading-screen',{attrs:{"show":true}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }